import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatCurrency } from '@/utils/priceHelpers';

export function useSessionDetailsSummary() {
  const { t } = useI18n();

  const getDifferenceClass = (actual: number | null | undefined, expected: number | null | undefined): string => {
    if (!actual || !expected) return '';
    const diff = actual - expected;
    if (diff > 0) return 'text-green-600 dark:text-green-400';
    if (diff < 0) return 'text-red-600 dark:text-red-400';
    return 'text-gray-600 dark:text-gray-400';
  };

  const getDifferenceTextClass = (actual: number | null | undefined, expected: number | null | undefined): string => {
    if (!actual || !expected) return 'text-gray-500';
    const diff = actual - expected;
    if (diff > 0) return 'text-green-600 dark:text-green-400';
    if (diff < 0) return 'text-red-600 dark:text-red-400';
    return 'text-gray-500';
  };

  const getDifferenceLabel = (actual: number | null | undefined, expected: number | null | undefined): string => {
    if (!actual || !expected) return '';
    const diff = actual - expected;
    if (diff > 0) return t('app.views.cashRegister.surplus');
    if (diff < 0) return t('app.views.cashRegister.shortage');
    return t('app.views.cashRegister.balanced');
  };

  const formatDifference = (actual: number | null | undefined, expected: number | null | undefined): string => {
    if (!actual || !expected) return formatCurrency(0);
    const diff = actual - expected;
    return formatCurrency(Math.abs(diff));
  };

  return {
    getDifferenceClass,
    getDifferenceTextClass,
    getDifferenceLabel,
    formatDifference,
  };
}
